import React, { useEffect } from 'react'
import { Row, Col } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'

import { HoverCard, ResponsiveCard, ResponsiveIcon, ResponsiveDiv } from '../../components.style'
import { useTranslation } from 'react-i18next'
const SelectCurrency = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const wallets = useSelector((state) => state.wallet.wallets)
  const deposit = useSelector((state) => state.deposit)

  useEffect(() => {
    // set default wallet id
    if (wallets?.length > 0 && deposit.wallet.id == null) {
      dispatch({ type: 'SET_DEPOSIT_WALLET_ID', id: wallets[0].id })
    }
    // eslint-disable-next-line
  }, [wallets])

  return (
    <>
      <h5>{t("financial.selectCurrency")}</h5>

      <Row>
        {wallets?.length > 0 &&
          wallets.map((wallet) => {
            return (
              <Col sm="12" lg="6" key={wallet.id}>
                <HoverCard
                  isSelected={deposit?.wallet?.id === wallet.id ? '#f9b600' : null}
                  onClick={() => {
                    dispatch({ type: 'SET_DEPOSIT_WALLET_ID', id: wallet.id })
                  }}
                >
                  <ResponsiveCard>
                    <ResponsiveIcon className="icofont icofont-cur-dollar" />
                    <ResponsiveDiv>
                      <h6>{`${wallet.currency?.name}`}</h6>
                      <p>{`${t("financial.availableBalanceInWallet")} ${wallet.balance?.toFixed(2)}`}</p>
                    </ResponsiveDiv>
                  </ResponsiveCard>
                </HoverCard>
              </Col>
            )
          })}
      </Row>
    </>
  )
}

export default SelectCurrency
